import {ErrorWrapper, ResponseWrapper} from '@/core/service/util'
import {RoomBaseApiService} from '@/core/service/room.baseapi.service'
import {Http} from '@/core/service/http.init'
import {AuthService} from "@/core/service/auth.service";

class RoomService extends RoomBaseApiService {
  constructor() {
    super()
  }
  async createRoom(room) {
    try {
      const response = await this.request({
        auth: true
      }).post(`/api/v3/room`, room)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getRoom({ roomId, roomUrlId }) {
    try {
      let params
      if (!roomId && roomUrlId) {
        roomId = roomUrlId
        params = `?type=roomUrlId`
      }
      const response = await this.request().get(
        `/api/v3/room/${roomId || this.getRoomId()}${params || ''}`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async checkRoom({ roomId, roomUrlId }) {
    try {
      let params
      if (!roomId && roomUrlId) {
        roomId = roomUrlId
        params = `?type=roomUrlId`
      }
      const response = await this.request({auth: false}).get(
          `/api/v3/room/${roomId || this.getRoomId()}/checkRoom${params || ''}`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async enter({ roomId, tokenId }) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${roomId}/enter`, 
          { tokenId })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async leave({ reason }) {
    // try {
    //   const response = await this.request().post(
    //       `/api/v3/room/${this.getRoomId()}/leave`,
    //       { reason })
    //   return new ResponseWrapper(response, response.data.data)
    // } catch (error) {
    //   throw new ErrorWrapper(error)
    // }
    let blob = new Blob([JSON.stringify({
      roomToken: AuthService.getRoomAuthToken(),
      reason
    })], {
      type: 'application/json'
    });
    navigator.sendBeacon(`${process.env.VUE_APP_API_URL}/api/v3/room/${this.getRoomId()}/leave/beacon`, blob);
  }

  async changeRoomMode(roomMode) {
    try {
      const response = await this.request().post(
        `/api/v3/room/${this.getRoomId()}/mode`,
        { roomMode }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async changeRoomTitle(roomTitle) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/changeTitle`,
          { roomTitle }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async changeDefinePasswd(data) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/changeDefinePasswd`,
          data
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}

export const roomService = new RoomService()
